import Nav from "@/components/Nav";
import api from "@/lib/api";
import { useCallback, useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/notifications");
    setNotifs(data.notifications || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  const test = async () => {
    await api.post("/notifications/test");
    toast.success("Test notification sent (MOCKED WhatsApp + Email)");
    load();
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Nav />
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex items-start justify-between">
          <div>
            <div className="overline">Notifications</div>
            <h1 className="font-serif-display text-4xl text-[#1E1B4B] mt-2">Your intelligent updates.</h1>
            <p className="mt-3 text-stone-600">WhatsApp (Twilio) + Email (Resend) — <b>MOCKED</b> for demo.</p>
          </div>
          <button data-testid="notif-test-btn" onClick={test} className="btn-pill text-white text-sm" style={{ background: "#1E1B4B" }}>Send test</button>
        </div>

        <div className="mt-10 space-y-3">
          {notifs.length === 0 && <div className="text-stone-400 text-center py-16">No notifications yet.</div>}
          {notifs.map((n) => (
            <div key={n.id} className="border border-stone-200 rounded-2xl bg-white p-5 flex gap-4">
              <Bell className="text-amber-700 mt-0.5" size={18} />
              <div className="flex-1">
                <div className="text-sm text-stone-800">{n.message}</div>
                <div className="text-xs text-stone-400 mt-1">{new Date(n.created_at).toLocaleString()} · {n.channel} · {n.status}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
